export default "__VITE_ASSET__1hegLtsG__"